<nav aria-label="Page navigation">
  <ul class="pagination">
    @if (totalPages > 1) {
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" (click)="changePage(currentPage - 1)" aria-label="Previous">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
    }
    @if (pages[0] > 1) {
      <li class="page-item">
        <a class="page-link" (click)="changePage(1)">1</a>
      </li>
    }
    @if (pages[0] > 2) {
      <li class="page-item">
        <span class="page-link">...</span>
      </li>
    }
    @for (page of pages; track page) {
      <li class="page-item" [class.active]="page === currentPage">
        <a class="page-link" (click)="changePage(page)">{{ page }}</a>
      </li>
    }
    @if (pages[pages.length - 1] < totalPages - 1) {
      <li class="page-item">
        <span class="page-link">...</span>
      </li>
    }
    @if (pages[pages.length - 1] < totalPages) {
      <li class="page-item">
        <a class="page-link" (click)="changePage(totalPages)">{{ totalPages }}</a>
      </li>
    }
    @if (totalPages > 1) {
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" (click)="changePage(currentPage + 1)" aria-label="Next">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    }
  </ul>
</nav>
